<template>
  <div class="deo-box">
    <div class="user-box">
      <user-avatar :width="18" :height="18" :font-size="12" :img="detail.avatarUrl" :text="detail.nickname"></user-avatar>
      <span>{{detail.nickname}}</span>
    </div>
    <div class="deo-address-box">
      <div class="flex">
        售后类型：{{detail.type?"退货退款":"退款"}}
      </div>
      <div class="text" v-if="detail.money">
        退款金额：{{detail.money}}
      </div>
    </div>
  </div>
</template>

<script>

import UserAvatar from "@/components/base/user-avatar.vue";

export default {
  props:{
    detail:{
      type:Object,
      required:true
    }
  },
  name: "refund-box",
  components: {UserAvatar},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {
    getMobile(mobile){
      if(mobile){
        return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
      }
      return "";
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.user-box{
  display: flex;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  span{
    margin-left: 10px;
  }
}
.deo-address-box{
  font-size: 12px;
  color:#666;
  line-height: 18px;
}
</style>
